<div class="carousel-container">
  <!-- Main image display -->
  <div class="main-image-container">
    <button mat-icon-button class="nav-button prev-button" (click)="previous()" [disabled]="currentIndex === 0">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <div class="image-wrapper">
      <img [src]="data.images[currentIndex].fileUrl" [alt]="data.images[currentIndex].fileName">
    </div>

    <button mat-icon-button class="nav-button next-button" (click)="next()"
            [disabled]="currentIndex === data.images.length - 1">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <!-- Thumbnail strip -->
  <div class="thumbnail-container">
    <button mat-icon-button class="thumbnail-nav-button" (click)="previousThumbnailSet()"
            [disabled]="thumbnailStartIndex === 0">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <div class="thumbnails-wrapper">
      <div class="thumbnail" *ngFor="let image of visibleThumbnails; let i = index"
           [class.active]="currentIndex === thumbnailStartIndex + i"
           (click)="setCurrentImage(thumbnailStartIndex + i)">
        <img [src]="image.fileUrl" [alt]="image.fileName">
      </div>
    </div>

    <button mat-icon-button class="thumbnail-nav-button" (click)="nextThumbnailSet()"
            [disabled]="thumbnailStartIndex + thumbnailsToShow >= data.images.length">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <button mat-icon-button class="close-button" (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
